import { useQuery } from "@tanstack/react-query";
import { getWorkerTimeline } from "../api/workers";
import type { TimelineQuery } from "../api/types";

export function useWorkerTimeline(
  query: TimelineQuery,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: [
      "tawa",
      "worker",
      "timeline",
      query.worker_url,
      query.from ?? null,
      query.to ?? null,
      query.limit ?? null,
    ],
    queryFn: () => getWorkerTimeline(query),
    enabled: (options?.enabled ?? true) && !!query.worker_url,
    staleTime: 30_000,
  });
}
